import React from 'react';
import classes from './index.module.scss';

const Subtitle = ({ text, style, className }) => (
  <h4 className={[classes.subTitle, className].join(' ')} id="subtitle-text-generic" style={style}>
    {text}
  </h4>
);
export default Subtitle;
